import type { SettingsState } from '@/types/settings'

/**
 * Die Top-Level-Keys aus `next`, deren Wert sich gegenüber `current` geändert
 * hat — genau das, was `PATCH /settings` bekommen soll.
 *
 * Nur Keys aus `next` zählen: fehlt ein Key dort (etwa `windowConfigurations`
 * in den Standardwerten), ist das keine Aufforderung, ihn zu löschen.
 * Verglichen wird per JSON, weil Aufrufer verschachtelte Objekte neu bauen,
 * auch wenn sich inhaltlich nichts geändert hat.
 */
export function changedSettings(current: SettingsState, next: SettingsState): Partial<SettingsState> {
  const changes: Record<string, unknown> = {}
  for (const key of Object.keys(next) as (keyof SettingsState)[]) {
    if (JSON.stringify(next[key]) !== JSON.stringify(current[key])) {
      changes[key] = next[key]
    }
  }
  return changes as Partial<SettingsState>
}
